module.exports = __webpack_public_path__ + "static/media/majorC1.fe3ea21.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorC1.wav
// module id = Pqa1
// module chunks = 0